function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M331-384q-8.1 0-13.05-5.4Q313-394.8 313-402q0-1 5.88-12.77L461-557q4-4 9-6t10-2q5 0 10 2t9 6l142.12 142.19q2.94 2.95 4.41 6.38Q647-405 647-401.5q0 7-4.95 12.25T629-384H331Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#eeeeee"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow_drop_up.f6e957d8.svg";
export { SvgComponent as ReactComponent };